import type { Lang } from '@vlm/i18n';
import { prefs, usePrefs as useSharedPrefs, type Theme } from '@vlm/ui';

export { useScheme, type Theme } from '@vlm/ui';

/**
 * The reader's theme and language: the one store in @vlm/ui (the platform's too), with the shape
 * this app has always read — `usePrefs((s) => s.lang)`, `usePrefs.getState().setLang(…)`.
 */
interface Prefs {
  theme: Theme;
  lang: Lang;
  setTheme: (theme: Theme) => void;
  /** Local only; the caller syncs the signed-in user's profile when it should. */
  setLang: (lang: Lang) => void;
}

const actions = { setTheme: prefs.setTheme, setLang: prefs.setLang };

export function usePrefs<T>(select: (s: Prefs) => T): T {
  return useSharedPrefs((p) => select({ ...p, ...actions }));
}

usePrefs.getState = (): Prefs => ({ ...prefs.get(), ...actions });
